import React from "react";
import { FaReddit, FaXTwitter, FaFacebook, FaTelegram } from "react-icons/fa6";

interface ShareButtonsProps {
    title: string;
    url?: string;
}

export const ShareButtons: React.FC<ShareButtonsProps> = ({ title, url = "https://scoresmart.in" }) => {
    const encodedTitle = encodeURIComponent(title);
    const encodedUrl = encodeURIComponent(url);

    const shares = [
        {
            name: "X",
            icon: <FaXTwitter />,
            color: "#000000",
            link: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`
        },
        {
            name: "Reddit",
            icon: <FaReddit />,
            color: "#FF4500",
            link: `https://reddit.com/submit?title=${encodedTitle}&url=${encodedUrl}`
        },
        {
            name: "Facebook",
            icon: <FaFacebook />,
            color: "#1877F2",
            link: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`
        },
        {
            name: "Telegram",
            icon: <FaTelegram />,
            color: "#0088cc",
            link: `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`
        }
    ];

    return (
        <div className="share-buttons-container" style={{ display: 'flex', gap: '8px', alignItems: 'center', marginTop: '12px' }}>
            <span style={{ fontSize: '0.8rem', fontWeight: 'bold', color: '#64748b', marginRight: '4px' }}>SHARE:</span>
            {shares.map(s => (
                <a
                    key={s.name}
                    href={s.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={`Share on ${s.name}`}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        background: 'white',
                        color: s.color,
                        border: `1px solid ${s.color}22`,
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                        transition: 'all 0.2s ease',
                        fontSize: '1.2rem'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.background = s.color;
                        e.currentTarget.style.color = 'white';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.background = 'white';
                        e.currentTarget.style.color = s.color;
                    }}
                >
                    {s.icon}
                </a>
            ))}
        </div>
    );
};
